module.exports = __webpack_public_path__ + "img/img-f95a930e.b8293b9d.png";